import { CdekCityInfo } from '@shared/types/cdek';
import FetchData from '@shared/utils/fetchData/fetchData';

export const getCdekCityInfo = async (code: number) => {
  const res = await FetchData.get<CdekCityInfo>(`v2/delivery/location/city?city_code=${code}`, {});

  return res.data;
};
